import styled from 'styled-components'
import { screenBlockerZIndex } from '../common'

export const CenterDivOnScreen = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`

export const ScreenCover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${props => props.zIndex || screenBlockerZIndex};
  background-color: ${props => props.backgroundColor || 'transparent'};
  overflow: none;
`

// For the next 4, the parent must have the style position: relative.
export const ParentCover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${props => props.zIndex || screenBlockerZIndex};
  overflow: none;
`

export const CenterInParent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`

export const CenterVerticalInParent = styled.div`
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
`

export const CenterHorizontalInParent = styled.div`
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
`

export const AlignToBottomOfParent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
`

export const YDivider = styled.div`
  height: ${props => props.height};
`

export const XDivider = styled.div`
  display: inline-block;
  width: ${props => props.width};
`

export const InlineBlock = styled.div`
  display: inline-block;
`

export const FloatLeft = styled.div`
  float: left;
`

export const FloatRight = styled.div`
  float: right;
`

export const FloatClear = styled.div`
  clear: both;
`

export const CenterText = styled.div`
  text-align: center;
`

export const FlexByRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const CreateJobIntentContainer = styled.div`
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 220px));
  width: 70vw;
  gap: 30px
`

export const CreateTemplateIntentContainer = styled.div`
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 220px));
  width: 70vw;
  gap: 30px
`

export const CreateTemplateAccountsIntentContainer = styled.div`
  margin-bottom: 30px; 
  display: grid;
  grid-template-columns: repeat(5, minmax(220px, 270px));
  width: 70vw;
  gap: 30px
`

export const CreateTemplateAccountsIntentContainerSmtCtlg = styled.div`
  margin-bottom: 30px; 
  display: grid;
  grid-template-columns: repeat(5, minmax(220px, 270px));
  width: 90vw;
  gap: 30px
`

export const CreateJobCheckBoxIntentContainer = styled.div`
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 270px));
  width: 70vw;
  gap: 30px
`

export const CreateJobDatesIntentContainer = styled.div`
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 220px));
  width: 70vw;
  gap: 30px
`

export const FlexByRowCentered = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const FlexGrowOne = styled.div`
  flex-grow: 1;
`

export const HalfScreen = styled.div`
  width: 50%;
  flex-grow: 1;
`

export const AlignLeft = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const FlexByRowCenteredVertical = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const EllipsisText = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
  
export { useTheme, makeStyles, withStyles } from '@material-ui/core/styles'